(() => {
  const emit = (name, data) => {
    const shopify = window.Shopify;
    if (shopify?.designMode || !shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (typeof shopify?.analytics?.publish !== 'function') return;
    try { Promise.resolve(shopify.analytics.publish(`kde:${name}`, data)).catch(() => {}); } catch (_) {}
  };
  document.addEventListener('kde:variant_selected', event => {
    emit('variant_selected', event.detail);
  });
  document.addEventListener('change', event => {
    const finder = event.target.closest('kde-parts-finder');
    if (finder && event.target.id === 'kde-parts-model') emit('replacement_model_selected', {model: event.target.value});
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.sticky-cta button')) emit('sticky_add_clicked', {surface:'product'});
    if (event.target.closest('.kde-proof-link a')) emit('strength_proof_opened', {surface:'product'});
  }, true);
})();
